import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { getCityWallet, updateCityWallet } from "services/cityWallet";

/** Keyed per city — each city carries its own policy. */
export const cityWalletKeys = {
    all: ["city-wallet"],
    city: (cityId) => ["city-wallet", String(cityId)],
};

/**
 * One city's wallet policy, and the counts that make the warning real.
 *
 * @param {number|string|null} cityId Falsy disables the query, so the modal
 *   asks for nothing while it is closed.
 */
export const useCityWallet = (cityId) => {
    const query = useQuery({
        queryKey: cityWalletKeys.city(cityId),
        queryFn: () => getCityWallet(cityId),
        enabled: Boolean(cityId),
        // The driver counts move as drivers are topped up, so this must not
        // serve a stale warning.
        staleTime: 0,
    });

    return {
        policy: query.data ?? null,
        loading: query.isLoading,
        error: query.error?.response?.data?.message ?? null,
    };
};

export const useSaveCityWallet = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateCityWallet,
        onSuccess: (data, variables) => {
            // The PATCH answers with the whole policy, so seed the cache from
            // it — no stale window and no second GET.
            queryClient.setQueryData(cityWalletKeys.city(variables.cityId), data);
            // The cities list carries the same columns.
            queryClient.invalidateQueries({ queryKey: ["cities"] });
        },
    });
};
